export default {"src":"/_next/static/media/flower.17cc15cd.svg","height":640,"width":535,"blurWidth":0,"blurHeight":0};